import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { environment } from '../../environments/environment';
import { ErrorService } from './error.service';

@Injectable()
export class PushService {

	constructor(private http: HttpClient,
				private _swPush: SwPush,
				private _errorService: ErrorService) {

	}

	/**
	 * @api {post} /v2/PushInfo Send Push Notification Info
	 * @apiName addPushSubscriber
	 * @apiGroup PushInfo
	 * @apiVersion 20.0.0
	 */
	addPushSubscriber(sub: any) {
		const pushInfo = {
			endpoint: sub.endpoint,
			p256dh: sub.keys.p256dh,
			auth: sub.keys.auth
		};
		return this.http.post(`${environment.apiUrl}/v2/PushInfo`, pushInfo);
	}

	registerForPush() {
		if (environment.production) {
			this._swPush.requestSubscription({serverPublicKey: environment.vapidPublicKey}).then(sub => {
				this.addPushSubscriber(JSON.parse(JSON.stringify(sub))).subscribe(
					() => console.log('Sent push subscription object to server.'),
					(error) => this._errorService.error(error, 'Could not send subscription object to server, reason: ')
				);
			}).catch(error => this._errorService.error(error, 'Could not subscribe to notifications'));
		}
	}

}


